import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import layout from './modules/layout'
import theme from './modules/theme'
import account from './modules/account'
import loader from './modules/loader'
import grid from './modules/grid'
import stomp from './modules/stomp'
import message from './modules/message'
import configure from './modules/configure'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    global,
    layout,
    theme,
    account,
    loader,
    grid,
    stomp,
    message,
    configure
  }
})
export default store
